module.exports = __webpack_public_path__ + "img/bannerWrap.0698d1c3.png";